import PopChart from './components/PopChart';
import PopChart2 from './components/PopChart2';
import PopChart3 from './components/PopChart3';
import PopChart4 from './components/PopChart4';
import PopChart5 from './components/PopChart5';
import {
    Card,
    Grid,
} from '@mui/material';

const Page1 = () => {
    return (
        <>
            <Grid sx={{ p: 5 }}><text>
                <h2>Statistiken RAP</h2>
                <h3>Rechtsanwaltsprüfung (RAP)</h3>

                <p>   Hier finden Sie die Ergebnisse der in Österreich abgelegten Rechtsanwaltsprüfungen (RAP) grafisch aufgearbeitet. Die Zahlen werden bei den Präsidien der vier Oberlandesgerichte erhoben; für ältere Jahrgänge wurde auf die von Prof. Peter G. Mayr veröffentlichten (ebenfalls bei den Oberlandesgerichten erhobenen) Zahlen zurückgegriffen. Die Zahlen erfassen nur RAP im engeren Sinn, das heißt etwa keine Eignungsprüfungen nach dem EIRAG.
                </p><p>
                    Die einzelnen Grafiken können individuell angepasst werden, indem der interessierende Zeitraum und/oder OLG-Sprengel ausgewählt wird.
                </p>


            </text></Grid>

            <Card sx={{ mt: 5 }}>
                <Grid sx={{ p: 5 }}>
                    <Grid>
                        <div className="container">
                            <PopChart />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 3 }}>
                <Grid sx={{ p: 3 }}>
                    <Grid>
                        <div className="container">
                            <PopChart2 />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 3 }}>
                <Grid sx={{ p: 3 }}>
                    <Grid>
                        <div className="container">
                            <PopChart3 />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 3 }}>
                <Grid sx={{ p: 3 }}>
                    <Grid>
                        <div className="container">
                            <PopChart4 />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 3 }}>
                <Grid sx={{ p: 3 }}>
                    <Grid>
                        <div className="container">
                            <PopChart5 />
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </>
    )
};

export default Page1;